import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { tagApi } from "../api/tagApi";
import { PAGINATION } from "../constants/common";

export const useTags = (params) => {
  const queryKey = ["/tags", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await tagApi.getAll(params),
  });

  const create = useMutation({
    mutationFn: async (body) => await tagApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async (body) => await tagApi.update(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: async (id) => await tagApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    loading: isLoading,
    error,
    create,
    update,
    remove,
  };
};
